import { Info } from "lucide-react";

const TEXT =
  "Signal Edge compiles public statements for research purposes only. Nothing here constitutes investment advice.";

export function DisclaimerBanner() {
  return (
    <div
      data-testid="disclaimer-banner"
      className="flex items-start gap-2 border border-[#1e293b] bg-[#0f172a] px-4 py-2.5 text-xs text-[#94a3b8]"
    >
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#3b82f6]" />
      <span>{TEXT}</span>
    </div>
  );
}

export function DisclaimerFooter() {
  return (
    <footer
      data-testid="disclaimer-footer"
      className="mt-16 border-t border-[#1e293b] bg-[#0b1120] px-6 pt-5 text-[11px] leading-relaxed text-[#64748b]"
      style={{
        paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 1.25rem)",
        paddingLeft: "max(env(safe-area-inset-left, 0px), 1.5rem)",
        paddingRight: "max(env(safe-area-inset-right, 0px), 1.5rem)",
      }}
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="mb-1 font-mono text-[10px] uppercase tracking-[0.18em] text-[#475569]">
          Disclaimer
        </div>
        {TEXT}
      </div>
    </footer>
  );
}
